import React from "react";

import TrashImage from "../../../assets/result/result-b.png";

import ResultPageLayout from "../ResultPageLayout";

const ResultPage2 = () => {
  return (
    <ResultPageLayout
      img={TrashImage}
      title="보통의 시민!"
      hashText="길어야_일주일_정도"
    >
      당신은 환경에 나름 관심이 있네요!
      <br />이 정도면 <b>1주일</b> 정도 버티겠는걸요.
      <br />
      조금만 더 노력하면 환경러가 될 수 있답니다.
      <br />
      <br />
      어떤 선택지에서 쓰레기가
      <br />
      가장 많이 나왔는지 돌이켜볼까요?
      <br />
      <br />
      나의 노력으로 줄일 수 있는 선택이었는지,
      <br />
      기업·정부의 노력이 있었다면
      <br />
      더 줄일 수 있는 쓰레기는 아니었을지
      <br />
      함께 생각해 보아요.
      <br />
      <br />
      우리의 노력으로 쓰레기를
      <br />
      줄일 수 있는 상황이었다면,
      <br />
      <b>지금부터 함께 실천</b>해요!
      <br />
      <br />
      주변에 제로웨이스트샵이 있는지 찾아보고,
      <br />
      주말에 한 번 다녀와 보는 것을 추천할게요.
      <br />
      포장 쓰레기가 나오지 않는
      <br />
      소비에 맛을 들리게 될지도 몰라요:)
      <br />
      <br />
      그 외에도 배달음식 줄이기,
      <br />
      꼭 필요한 물품만 구매하기 등<br />
      다양한 노력들을 할 수 있답니다.
      <br />
      <br />
      <b>
        물론, 기업과 정부가
        <br />
        나의 선택지를 늘려주면 가장 좋겠지요.
      </b>
      <br />
      <br />
      쓰레기를 줄이기 위해 필요하다고
      <br />
      생각하는 <b>정책 혹은 의견을 남겨주세요!</b>
    </ResultPageLayout>
  );
};

export default ResultPage2;
